import React, { Component } from 'react';
import { FaPause, FaSortDown, FaSortUp } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../../axios-local-api';
import Confirm from '../../../components/UI/Confirm/Confirm';
import Modal from '../../../components/UI/Modal/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { sortDataByKey } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import classes from './AddDevicesToGroup.css';

export class AddDevicesToGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrow: true,
      deviceMacs: new Map(),
      action: '',
      result: null,
      confirmModal: false,
      showMore: false,
      currentRecords: this.buildDeviceGroupData(this.props.devices, this.props),
      sortBy: 'deviceSignalStatus',
      sortDirection: 'asc',
    };
    this.addDevicesGroupHandler = this.addDevicesGroupHandler.bind(this);
    this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
  }

  componentDidMount() {
    this.setState(
      {
        currentRecords: this.buildDeviceGroupData(
          this.props.devices,
          this.props
        ),
        sortDirection: 'asc',
      },
      () => {
        this.sortTable('deviceSignalStatus');
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading !== this.props.loading) {
      this.setState({
        currentRecords: null,
        sortDirection: 'asc',
      });
    }

    if (
      !this.state.currentRecords &&
      nextProps.devices &&
      nextProps.devices.length
    ) {
      this.setState(
        {
          currentRecords: this.buildDeviceGroupData(
            nextProps.devices,
            nextProps
          ),
          sortDirection: 'asc',
        },
        () => {
          this.sortTable('deviceSignalStatus');
        }
      );
    }
  }
  componentWillUpdate() { }
  componentDidUpdate() { }

  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }

  resetUpArrow() {
    this.setState({
      upArrow: false,
    });
  }

  handleDeviceCheckBox = (e) => {
    let deviceMac = e.target.value;
    let checked = e.target.checked;
    this.setState(
      (prevState, props) => {
        return {
          deviceMacs: prevState.deviceMacs.set(deviceMac, checked),
        };
      },
      () => {
      }
    );
  };

  getDeviceModel = (device) => {
    if (!this.props.advancedDeviceIds) {
      return 'N/A';
    }
    let adid = this.props.advancedDeviceIds[device.mac];
    if (!adid.advancedDeviceId) {
      return 'N/A';
    }
    return adid.advancedDeviceId.model;
  };
  getDeviceGroups = () => {
    let groupMap = {};
    if (this.props.deviceGroups) {
      this.props.deviceGroups.forEach((group) => {
        if (!group.devices) return;
        group.devices.forEach((device) => {
          groupMap[device.mac] = group.nickname;
        });
      });
    }
    return groupMap;
  };

  getDeviceName = (device) => {
    let deviceName;
    if (
      !device.nickname ||
      device.nickname === undefined ||
      (device.nickname && !device.nickname.length) ||
      device.nickname === null
    ) {
      deviceName = device.name;
    } else {
      if (device.nickname.indexOf('|') !== -1) {
        deviceName = device.nickname.slice(
          device.nickname.indexOf('|') + 1,
          device.nickname.length
        );
      } else deviceName = device.nickname;
    }

    if (deviceName === undefined || deviceName.length === 0) {

      if (device.mac) {
        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[device.mac] && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']) {
          if (this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['modelAccuracyLevel']
            && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['modelAccuracyLevel'] > 4) {
            deviceName = this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['model'] ? this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['model'] : (this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['type'] ? this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['type'] : '');
          }
        }
        if ((deviceName === undefined || deviceName.length === 0) && this.props.advancedDeviceIds && this.props.advancedDeviceIds[device.mac] && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']) {
          deviceName = this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['dhcpHostname'];
        }
        if (deviceName === undefined || deviceName.length === 0) {
          deviceName = device.mac;
        };
      }
      if (deviceName === undefined || deviceName.length === 0) {
        deviceName = "Unknown";
      }
    }
    return deviceName;
  };
  handleShowMoreClick() {
    if (!this.state.showMore) {
      this.setState({
        showMore: true,
      });
    } else {
      this.setState({
        showMore: false,
      });
    }
  }
  renderFirstRowData() {
    const { groupDetails } = this.props;
    const devices = this.state.currentRecords || [];
    let deviceGroups = this.getDeviceGroups();
    let addDevicelength = devices.length;
    const numberOfItems = this.state.showMore ? addDevicelength : 12;
    const addDevices = this.state.currentRecords || [];
    return addDevices.map((data) => {
      return (
        <tr>
          <td
            style={{
              display: 'flex',
              padding: '8px',
              borderRight: 'none',
              borderLeft: 'none',
              borderBottom: '1px solid lightgray !important',
            }}
          >
            <input
              type="checkbox"
              className={classes.DeviceCheckBox}
              checked={
                this.state.deviceMacs.get(data.mac) === null
                  ? false
                  : this.state.deviceMacs.get(data.mac)
              }
              name={data.mac}
              value={data.mac}
              onClick={this.handleDeviceCheckBox}
              aria-label={"Device Checkbox"}
            />
            <span className={classes.AddDeviceWrapText}>
              {this.getDeviceName(data)}{' '}
            </span>
          </td>
        </tr>
      );
    });
  }

  getDeviceModel = (device) => {
    if (!this.props.advancedDeviceIds) {
      return 'N/A';
    }
    let adid = this.props.advancedDeviceIds[device.mac];
    if (!adid.advancedDeviceId) {
      return 'N/A';
    }
    return adid.advancedDeviceId.model;
  };

  getSignalStatus = (element) => {
    let deviceSignalStatus = 'Disconnected';
    let status,
      paused = 'unpaused';
    if (element && element.freeze.frozen === true) {
      paused = 'paused';
    }
    if (element.health && element.health.status) {
      status =
        element.health.status.charAt(0).toUpperCase() +
        element.health.status.slice(1);
    } else {
      status = 'Disconnected';
    }
    if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      element.freeze.frozen === true
    ) {
      status = 'Paused';
      deviceSignalStatus = 'Paused';
    } else if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      element.capabilities
    ) {
      deviceSignalStatus = status;
    } else if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      !element.capabilities
    ) {
      deviceSignalStatus = status;
    }
    return { deviceSignalStatus, paused };
  };

  sortTable = (propertyName) => {
    const { sortDirection, currentRecords } = this.state;
    const records = sortDataByKey(currentRecords, propertyName, sortDirection);
    this.setState({
      currentRecords: records,
      sortDirection:
        sortDirection === '' || sortDirection === 'desc' ? 'asc' : 'desc',
      sortBy: propertyName,
    });
  };

  buildDeviceGroupData(devices = [], nextProps) {
    let deviceGroups = this.getDeviceGroups();
    let addDevices = [];
    if (devices !== null) {
      devices.forEach((data) => {
        let deviceGroupName = deviceGroups[data.mac];
        if (deviceGroupName !== this.props.groupDetails.nickname) {
          addDevices.push(data);
        }
      });
      return addDevices.map((device) => {
        const { deviceSignalStatus = '', paused = '' } =
          this.getSignalStatus(device);
        device.deviceName = this.getDeviceName(device) || '';
        device.currentGroup = deviceGroups[device.mac] || 'Ungrouped';
        device.deviceModel = this.getDeviceModel(device) || '';
        device.deviceSignalStatus = deviceSignalStatus;
        device.paused = paused;
        return device;
      });
    }
  }

  renderRowData(type) {
    const { groupDetails } = this.props;
    const devices = this.state.currentRecords || [];
    let deviceGroups = this.getDeviceGroups();
    let addDevicelength = devices.length;
    const numberOfItems = this.state.showMore ? addDevicelength : 12;
    const colorCode = {
      connected: 'green',
      excellent: 'green',
      disconnected: '#6F777E',
      poor: 'red',
      good: 'green',
      fair: 'red',
      calculating: 'orange',
    };
    const addDevices = this.state.currentRecords || [];
    return addDevices.map((data) => {
      let deviceGroupName = deviceGroups[data.mac];
      if (deviceGroupName === this.props.groupDetails.nickname) {
        return null;
      }

      if (!deviceGroupName) {
        deviceGroupName = 'Ungrouped';
      }
      let status;
      if (data.health && data.health.status) {
        status =
          data.health.status.charAt(0).toUpperCase() +
          data.health.status.slice(1);
      } else {
        status = 'Disconnected';
      }
      let paused = '';
      if (data.freeze.frozen === true) {
        paused = <FaPause color={'gray'} />;
      }

      let statusColor, statusClass;
      if (status === 'N/A') {
        statusColor = { color: 'red' };
        statusClass = classes.poor;
      } else {
        statusColor = {
          color: data.health
            ? colorCode[data.health.status]
            : colorCode.disconnected,
        };
        statusClass = data.health
          ? classes[data.health.status]
          : classes.disconnected;
      }
      let colorDot;
      if (data.deviceSignalStatus === 'Calculating') {
        colorDot = (
          <div
            className={classes.colorDot}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div className={classes.Calculating}></div>
            <div style={{ width: '10px' }} />
            <div style={{ color: colorCode.calculating }}>{status}</div>
          </div>
        );
      } else if (
        data.connectionState &&
        data.connectionState === 'connected' &&
        data.freeze.frozen === true
      ) {
        status = 'Paused';
        colorDot = (
          <div
            className={classes.colorDot}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div className={classes.Paused}></div>
            <div style={{ width: '10px' }} />
            <div>Paused</div>
          </div>
        );
      } else if (
        data.connectionState &&
        data.connectionState === 'connected' &&
        data.capabilities
      ) {
        colorDot = (
          <div
            className={classes.colorDot}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div
              className={
                status === 'Poor' || status === 'Fair' ? classes.NotConnected : classes.Connected
              }
            ></div>
            <div style={{ width: '10px' }} />
            <div
              style={{
                color: status === 'Poor' || status === 'Fair' ? colorCode.poor : colorCode.connected,
              }}
            >
              {status}
            </div>
          </div>
        );
      } else if (
        data.connectionState &&
        data.connectionState === 'connected' &&
        !data.capabilities
      ) {
        colorDot = (
          <div
            className={classes.colorDot}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div className={classes.NotConnected}></div>
            <div style={{ width: '10px' }} />
            <div styles={{ color: colorCode.disconnected }}>{status}</div>
          </div>
        );
      } else {
        colorDot = (
          <div
            className={classes.colorDot}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div className={classes.NotConnected}></div>
            <div style={{ width: '10px' }} />
            <div style={{ color: colorCode.poor }}>Disconnected</div>
          </div>
        );
      }
      let deviceNameHtml;
      if (type === 'Desktop') {
        deviceNameHtml = (
          <td>
            <div style={{ display: 'flex' }}>
              <input
                id="AddDeviceCheckBox"
                type="checkbox"
                className={classes.DeviceCheckBox}
                checked={
                  this.state.deviceMacs.get(data.mac) === null
                    ? false
                    : this.state.deviceMacs.get(data.mac)
                }
                name={data.mac}
                value={data.mac}
                onClick={this.handleDeviceCheckBox}
                aria-label={"Handle Device Check Box"}
              />
              <span id="DeviceName" className={classes.AddDeviceWrapText}>
                {this.getDeviceName(data)}{' '}
              </span>
            </div>
          </td>
        );
      } else {
        deviceNameHtml = '';
      }

      return (
        <tr>
          {deviceNameHtml}
          <td className={classes.AddDeviceBorderLine}>{colorDot}</td>
          <td
            className={classes.AddDeviceBorderLine}
            style={{ width: '100px' }}
          >
            <span
              style={{
                wordWrap: 'normal',
                display: 'block',
                width: '235px',
                whiteSpace: 'normal',
              }}
            >
              {this.getDeviceModel(data)}
            </span>
          </td>
          <td
            className={classes.AddDeviceBorderLine}
            style={{ whiteSpace: 'pre' }}
          >
            {deviceGroupName}
          </td>
          <td className={classes.AddDeviceBorderLine} style={{ textAlign: 'center' }}>{paused}</td>
        </tr>
      );
    });
  }
  renderTableInfo(type) {
    let showMoreHtml;
    let showtr;
    let addDevicelength =
      this.props.devices.length - this.props.groupDetails.devices.length;
    let sortIcon;
    const { sortDirection, sortBy, currentRecords } = this.state;
    if (sortDirection === 'desc') {
      sortIcon = <FaSortUp fontSize={'18px'} />;
    } else if (sortDirection === 'asc') {
      sortIcon = <FaSortDown fontSize={'18px'} />;
    }

    if (type === 'Desktop') {
      return (
        <React.Fragment>
          <thead>
            <tr className={classes.trTag}>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('deviceName');
                }}
              >
                Device Name {sortBy === 'deviceName' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('deviceSignalStatus');
                }}
              >
                Signal {sortBy === 'deviceSignalStatus' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('deviceModel');
                }}
              >
                Device Model {sortBy === 'deviceModel' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('currentGroup');
                }}
              >
                Current Group {sortBy === 'currentGroup' && sortIcon}
              </th>
              <th
                style={{
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'center',
                  padding: '16px',
                  color: 'grey',
                  borderBottom: '1px solid lightgrey',
                }}
                onClick={() => {
                  this.sortTable('paused');
                }}
              >
                Pause {sortBy === 'paused' && sortIcon}
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData(type)}
            {/* {showMoreHtml} */}
          </tbody>
        </React.Fragment>
      );
    } else {
      let table1 = (
        <div style={{ float: 'left' }}>
          <table className={classes.devTable} cellPadding="0" cellSpacing="0">
            <thead>
              <tr className={classes.trTag}>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '8px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceName');
                  }}
                >
                  Device Name {sortBy === 'deviceName' && sortIcon}
                </th>
              </tr>
            </thead>
            <tbody>
              {this.renderFirstRowData()}
              {/* {showMoreHtml} */}
            </tbody>
          </table>
        </div>
      );

      let table2 = (
        <div className={classes.tableWrapper}>
          <table className={classes.devTable} cellPadding="0" cellSpacing="0">
            <thead>
              <tr className={classes.trTag}>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceSignalStatus');
                  }}
                >
                  Signal {sortBy === 'deviceSignalStatus' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceModel');
                  }}
                >
                  Device Model {sortBy === 'deviceModel' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('currentGroup');
                  }}
                >
                  Current Group {sortBy === 'currentGroup' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'center',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('paused');
                  }}
                >
                  Pause {sortBy === 'paused' && sortIcon}
                </th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData(type)}
              {showtr}
            </tbody>
          </table>
        </div>
      );
      return (
        <div style={{ display: 'flex' }}>
          {table1}
          {table2}
        </div>
      );
    }
  }
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  confirmModalConfirmHandler = () => {
    let selectedMacs = [];
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        selectedMacs.push(mac);
      }
    });


    this.props.groupDetails.devices.forEach((data) => {
      selectedMacs.push(data.mac);
    });

    let payload = {
      grpAssignedDevices: selectedMacs,
      grpName: this.props.groupDetails.nickname,
      grpIcon: this.props.groupDetails.imageId,
      grpId: this.props.groupDetails.id,
      grpPrimaryDevice: this.props.groupDetails.primaryDevice,
      type: 'assignDevice',
    };
    // console.log('payload' ,payload);

    this.props.changeDeviceGroupDetails(payload);

    this.confirmModalCancelHandler('close');
  };

  confirmModalCancelHandler = (e) => {
    this.setState({ confirmModal: false, deviceMacs: new Map() });
    if (e === 'close') {
    }
  };

  addDevicesGroupHandler = (e) => {
    let newDevicesToAdd = [];
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        this.props.devices.forEach((data) => {
          if (mac === data.mac) {
            newDevicesToAdd.push(data);
          }
        });
      }
    });
    // console.log('this.props.handleGroupSteering :::', this.props.handleGroupSteering(newDevicesToAdd, 'ADD_DEVICE'));
    if (this.props.isGroupSuspend || (!this.props.handleGroupSteering(newDevicesToAdd, 'ADD_DEVICE')) || (this.props.handleGroupSteering(newDevicesToAdd, 'ADD_DEVICE'))){
      const modalContent = (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <h2>Add Device</h2>
          <p style={{ fontWeight: 'normal', textAlign: 'center', margin: '2px' }}>
            Devices being added to a new group will lose their current pause
            schedules and inherit the new group's schedule if one exists.
          </p>
          <p style={{ fontWeight: 'normal', textAlign: 'center', margin: '5px' }}>
            Are you sure you want to add the selected devices to this group?
          </p>
        </div>
      );

      this.onOpenModal(modalContent);
    }
    // else {
    //   (this.props.isGroupSuspend || this.props.handleGroupSteering(newDevicesToAdd, 'ADD_DEVICE')  )
    //   this.onOpenModal(modalContent);
    // }
  };
  render() {
    let showSaveBtn = true;
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        showSaveBtn = false;
      }
    });
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow) {
      arrow = <MdKeyboardArrowUp color={'#0073d1'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'#0073d1'} size={'30px'} />;
    }
    let infoRow;
    if (this.props.loading || !this.props.loaded && this.props.groupLoading || !this.props.groupLoaded) {
      infoRow = <Spinner />;
    } else if (
      !this.props.devices ||
      !this.props.groupDetails ||
      !this.props.groupDetails.devices
    ) {
      infoRow = (
        <div className={classes.InfoRow}>
          <div id= 'addDevicesNoDevice' style={{ color: 'gray' }}>
            There is no Device Information available at this time.
          </div>
        </div>
      );
    } else if (
      this.props.devices.length === this.props.groupDetails.devices.length
    ) {
      infoRow = (
        <div className={classes.InfoRow}>
          <div style={{ color: 'gray', textAlign: 'center' }}>
            No available device can be added at this time.
          </div>
        </div>
      );
    } else {
      infoRow = (
        <Box>
          <div className={classes.showDesktop}>
            <div className={classes.tableWrapper}>
              <table
                className={classes.GroupDeviceTable}
                cellPadding="0"
                cellSpacing="0"
              >
                {this.renderTableInfo('Desktop')}
              </table>
            </div>
          </div>
          <div className={classes.showMobile}>
            {this.renderTableInfo('Mobile')}
          </div>
          <button
            className={
              showSaveBtn ? classes.ActionButtonBlur : classes.ActionButton
            }
            id="addDeviceButton"
            disabled={showSaveBtn}
            onClick={this.addDevicesGroupHandler}
          >
            Add
          </button>
        </Box>
      );
    }
    return (
      <div
        className={classes.AddDeviceToGroupComponent}
        style={{ boxShadow: '#e2e1e1 0px 4px 2px -1px' }}
      >
        <div className={classes.showDesktop1}>
          {/* <Collapsible
        
        transitionTime={100}
        open= {true}
        onOpening={
          ()=>{this.openHandler()}

          }
        onClosing={
          ()=>{this.closeHandler()}
        }
        trigger={
          (<Box>
            <div className={classes.AddDeviceToGroupComponentCollapse}>
            <div className={classes.TitleArea}>
            <button className={classes.OpenCloseButton} aria-label="open arrow">
                {arrow}
              </button>
              <h2 style={{margin: '1rem',color: '#0073d1',fontSize: '16px'}}>Add Device</h2>
            </div>
              
              <div className={classes.HorizontalSeparator}/>
            
              </div>
          </Box>)
        }>
          {infoRow}
          
          </Collapsible> */}
          <h2 style={{ margin: '1rem', fontSize: '16px' }}>Add Device</h2>
          {infoRow}
        </div>
        <Modal
          deviceGroupConfirmation="true"
          show={this.state.confirmModal}
          modalClosed={this.confirmModalCancelHandler}
        >
          <Confirm
            id={'AddDeviceToGroupConfirm'}
            deviceGroupConfirmation="true"
            action={this.state.action}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Yes"
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.devices.loading,
    loaded: state.devices.loaded,
    groupLoading: state.deviceGroups.loading,
    groupLoaded: state.deviceGroups.loaded,
    advancedDeviceIds: state.devices.advancedDeviceIds,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDeviceGroupDetails: (payload) =>
      dispatch(actions.changeDeviceGroupDetails(payload)),
    deleteFreezesOnDevice: (deviceMac) =>
      dispatch(actions.deleteFreezesOnDevice(deviceMac)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddDevicesToGroup, api));
